import { HeaderAction } from "./HeaderAction";
import { HeaderCard } from "./HeaderCard";
import { HeaderCards } from "./HeaderCards";
import { HeaderContent } from "./HeaderContent";
import { HeaderRoot } from "./HeaderRoot";

export const Header = {
  Root: HeaderRoot,
  Content: HeaderContent,
  Cards: HeaderCards,
  Card: HeaderCard,
  Action: HeaderAction,
};
